import { Model } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";

export const CHUNKRANGE_MODEL_CHUNKS = 'chunks';

export class ChunkRangeModel extends Model {
    public chunks: Chunk[];
    public length: number;

    constructor() {
        super();
        this.chunks = [];
        this.length = 0;
    }

    addChunk( chunk: Chunk ) {
        var chunks = this.chunks;

        if( chunks.length ) {
            var prevChunk = chunks[chunks.length-1];
            prevChunk.next = chunk;
            chunk.prev = prevChunk
        }

        chunks.push( chunk );
        this.length++;

        this.setProperty( CHUNKRANGE_MODEL_CHUNKS, chunks );
        //console.log( '__ added chunk, next and prev are:', chunk.next, chunk.prev );
    }

    removeChunk( chunk: Chunk ) {
        var index = this.findChunkIndex( chunk );
        if( index !== null ) {
            var chunks = this.chunks;
            chunks[index].prev = null;
            chunks[index].next = null;
            chunks.splice( index,1 );
            this.length--;
            if( this.length > index+1 ) {
                chunks[index].next = chunks[index+1];
                chunks[index+1].prev = chunks[index];
            }
            this.setProperty( CHUNKRANGE_MODEL_CHUNKS, chunks );
        }
    }

    findChunkIndex( chunk: Chunk ) {
        for( var i = 0; i < this.chunks.length; i++ ) {
            if( this.chunks[i].isEqualTo( chunk ) ) {
                return i;
            }
        }
        return null;
    }

    findChunkByTimestamp( timestamp:number ): Chunk {
        for( var i = 0; i < this.chunks.length; i++ ) {
            if( this.chunks[i].start <= timestamp && this.chunks[i].end >= timestamp ) {
                return this.chunks[i];
            }
        }
        return null;
    }

    getChunk( index: number ) {
        return this.chunks[index];
    }

    getChunks() {
        return this.chunks;
    }

    setChunks( chunks: Chunk[] ) {
        this.length = chunks.length;

        for( var i = 0; i < chunks.length-1; i++ ) {
            chunks[i].next = chunks[i+1];
            if( i != 0 ) {
                chunks[i+1].prev = chunks[i];
            }
        }
        if( chunks.length ) {
            chunks[0].prev = null;
            chunks[chunks.length-1].next = null;
        }

        this.setProperty( CHUNKRANGE_MODEL_CHUNKS, chunks );
        //console.log( '__ set chunks' );
    }

    destroy() {
        this.length = 0;
        this.chunks = null;
        super.destroy();
    }
}